import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  stackableLabel: {
    description: 'FlagsRow Stackable card label',
    defaultMessage: 'Stackable',
    id: 'BeDcP/',
  },
  stackableHint: {
    description: 'FlagsRow Stackable card hint',
    defaultMessage: 'Safe to stack on itself in storage or transit',
    id: 'evfY+Y',
  },
  isSoldLabel: {
    description: 'FlagsRow Is sold card label',
    defaultMessage: 'Is sold',
    id: 'a6G/qL',
  },
  isSoldHint: {
    description: 'FlagsRow Is sold card hint',
    defaultMessage: 'Customers can order at this unit',
    id: 'IuBdop',
  },
  isStockedLabel: {
    description: 'FlagsRow Is stocked card label',
    defaultMessage: 'Is stocked',
    id: 'PgAwBK',
  },
  isStockedHint: {
    description: 'FlagsRow Is stocked card hint',
    defaultMessage: 'Tracked in warehouse inventory',
    id: 'Eu+LlR',
  },
});
